import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=4e28a764&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=js"
export * from "./productManage.vue?vue&type=script&lang=js"
import style0 from "./productManage.vue?vue&type=style&index=0&id=4e28a764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e28a764",
  null
  
)

export default component.exports